import {axiosNodeClient} from "../http";

export const userServiceNode = {get}

function get(id) {
    if (id && id > 0) {
        return axiosNodeClient.get(`/user/${id}`);
    } else {
        return axiosNodeClient.get('/user')
    }
}
